<template lang="pug">
  #users.center-panel.md-scrollbar.md-theme-default
    md-content.md-elevation-1(md-theme="white")
      user-menu
      .md-flex(md-theme="white")
        md-table(md-theme="white" v-if="modules && modules.length")
          router-link.md-table-row.link(v-for="(module, key) in modules" v-bind:key="module.id" tag="tr" v-bind:to="{ name: 'UserModuleActions', params: {code: module.code}, query: $route.query }")
            md-table-cell.name
              span.md-layout-row.md-gutter
                  span.md-flex.name
                      | {{module.description}}
            md-table-cell.load.right
              span.md-layout-row.md-gutter
                  span.md-flex.name {{(module.load) ? 'Загружен' : 'Не загружен' }}
            md-table-cell.active.right
              span.md-layout-row.md-gutter
                  span.md-flex.name {{(module.active) ? 'Активен' : 'Не активен' }}
</template>

<script>
    import UserMenu from './menu.vue';
    import SortTable from "@/components/SortTable";

    export default {
        components: {UserMenu, SortTable},
        data() {
            return {}
        },
        computed: {
            modules() {
                return this.$store.state.module.modules;
            },
        },
        created() {
            this.getModules();
            this.$store.commit('setTitle', 'Права');
        },
        methods: {
            getModules() {
                this.$store.dispatch('module/getModules');
            }
        }
    }
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// Modules.vue?4bda9853